import { render, staticRenderFns } from "./proposal-item-expenditure.vue?vue&type=template&id=35cdaa3b&scoped=true&"
import script from "./proposal-item-expenditure.vue?vue&type=script&lang=js&"
export * from "./proposal-item-expenditure.vue?vue&type=script&lang=js&"
import style0 from "./proposal-item-expenditure.vue?vue&type=style&index=0&id=35cdaa3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdaa3b",
  null
  
)

export default component.exports